<template>
  <div class="certificate-search">
    <van-nav-bar :title="title" left-arrow @click-left="$router.back()" />

    <van-form @submit="onSubmit">
      <van-field
        v-model="form.name"
        label="姓名"
        placeholder="请输入姓名"
        required
      />
      <van-field
        v-model="form.idnumber"
        label="身份证号"
        placeholder="请输入身份证号"
        :rules="[
          {
            pattern:
              /^\d{6}(18|19|20)?\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}(\d|X|x)$/,
            message: '请输入正确的身份证号',
          },
        ]"
        required
      />
      <van-field
        v-model="form.phone"
        label="手机号"
        placeholder="请输入手机号"
        :rules="[{ pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号' }]"
        required
      />

      <div>
        <Vcode :show="isShow" @success="onSuccess" @close="onClose" />
      </div>
      <van-button
        :type="verifyType"
        @click="submit"
        block
        style="margin-bottom: 10px"
        :disabled="isVerified"
        v-show="!isVerified"
        >{{ verifyText }}</van-button
      >
      <van-button
        type="primary"
        block
        native-type="submit"
        :disabled="!isVerified"
        v-if="false"
      >
        查询
      </van-button>
    </van-form>
  </div>
</template>
  
  <script>
import Vcode from "vue-puzzle-vcode";
export default {
  name: "CertificateSearch",
  components: {
    Vcode,
  },
  data() {
    return {
      queryType: "", // 查询类型
      title: "",
      form: {
        name: "",
        idnumber: "",
        phone: "",
      },
      isVerified: false,
      isShow: false,
      verifyType: "primary",
      verifyText: "查询",
    };
  },
  beforeRouteEnter(to, from, next) {
    // console.log("search to", to);
    // console.log("search from", from);
    if (from.path === "/result") {
      next(`/`);
    } else {
      next();
    }
  },
  mounted() {
    // 证书类型：1=aigc，2=职业资格证
    this.queryType = this.$route.query.type || "1"; // 默认 AIGC

    // 测试数据
    if (process.env.NODE_ENV === "development") {
      this.form = {
        name: this.queryType === "1" ? "郑宇" : "张林",
        idnumber:
          this.queryType === "1" ? "210403198207264211" : "612123198910109131",
        phone: this.queryType === "1" ? "15091633373" : "13734567890",
      };
    }

    // 页面标题
    this.title =
      this.$route.query.type === "1"
        ? "园区AIGC培训证信息查询"
        : "职业资格证查询";
  },
  methods: {
    validatePhone(phone) {
      const reg = /^1[3-9]\d{9}$/;
      return reg.test(phone);
    },

    validateIdNumber(idNumber) {
      const reg =
        /^\d{6}(18|19|20)?\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}(\d|X|x)$/;
      return reg.test(idNumber);
    },
    submit() {
      if (!this.form.name || !this.form.idnumber || !this.form.phone) {
        this.$toast.fail("请填写完整信息");
        return;
      }
      if (!this.validatePhone(this.form.phone)) {
        this.$toast.fail("请输入正确的手机号");
        return;
      }
      if (!this.validateIdNumber(this.form.idnumber)) {
        this.$toast.fail("请输入正确的身份证号");
        return;
      }
      this.isShow = true;
    },
    onSliderSuccess() {
      this.isVerified = true;
      this.$toast.success("验证通过");
      this.isShow = false;
    },
    onSliderFail() {
      this.isVerified = false;
      this.$toast.fail("验证失败，请重试");
    },
    onRefresh() {
      this.$toast.text("刷新验证码");
    },
    onSuccess(msg) {
      console.log("onSuccess", msg);
      this.isShow = false; // 通过验证后，需要手动关闭模态框
      this.$toast.success("验证通过");
      this.isVerified = true;
      this.verifyType = "info";
      this.verifyText = "验证通过";
      this.findCertificate();
    },
    onClose() {
      this.isShow = false;
    },
    onSubmit() {
      console.log("onSubmit");
      this.findCertificate();
    },

    findCertificate() {
      if (!this.form.name || !this.form.idnumber || !this.form.phone) {
        this.$toast.fail("请填写完整信息");
        return;
      }

      if (!this.isVerified) {
        // this.$toast("请先完成滑动验证");
        return;
      }

      this.$router.push({
        path: "/result",
        query: {
          type: this.queryType,
          name: this.form.name,
          idnumber: this.form.idnumber,
          phone: this.form.phone,
          verify: this.isVerified,
        },
      });
    },
  },
};
</script>
  
  <style scoped>
.certificate-search {
  padding: 20px;
  margin-bottom: 20px;
}
</style>
  